document.addEventListener('DOMContentLoaded', () => {

    /**
     * Système d'onglets générique.
     *
     * Utilisé par le bloc secteurs de l'accueil (.sectors) et par les onglets
     * des pages secteur (.sectorTabs). Un onglet et son panneau sont reliés par
     * la même valeur de data-sector-tab / data-sector-panel.
     *
     * Sur un conteneur marqué data-tabs-hash, l'onglet actif est reflété dans
     * l'ancre de l'URL : les liens directs (…/ma-page/#risques-industriels)
     * ouvrent le bon onglet.
     */
    const initTabs = (root) => {

        const tabs    = Array.from(root.querySelectorAll('[data-sector-tab]'));
        const panels  = Array.from(root.querySelectorAll('[data-sector-panel]'));
        const useHash = root.hasAttribute('data-tabs-hash');

        if (!tabs.length) return;

        const activate = (key, { focusTab = false, writeHash = false } = {}) => {

            const target = tabs.find(t => t.dataset.sectorTab === key);

            // Clé inconnue (ancre d'une autre section, par exemple) → on ignore
            if (!target) return false;

            tabs.forEach(tab => {
                const isActive = tab === target;
                tab.classList.toggle('is-active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.tabIndex = isActive ? 0 : -1;
            });

            panels.forEach(panel => {
                const isActive = panel.dataset.sectorPanel === key;
                panel.classList.toggle('is-active', isActive);
                panel.hidden = !isActive;
            });

            if (focusTab) target.focus();

            if (writeHash && useHash) {
                history.replaceState(null, '', '#' + key);
            }

            return true;
        };

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                activate(tab.dataset.sectorTab, { writeHash: true });
            });
        });

        // Navigation au clavier (pattern ARIA "tabs")
        root.addEventListener('keydown', e => {

            const current = tabs.indexOf(document.activeElement);
            if (current === -1) return;

            const moves = {
                ArrowLeft:  current - 1,
                ArrowRight: current + 1,
                Home:       0,
                End:        tabs.length - 1,
            };

            if (!(e.key in moves)) return;

            e.preventDefault();

            const next = (moves[e.key] + tabs.length) % tabs.length;
            activate(tabs[next].dataset.sectorTab, { focusTab: true, writeHash: true });
        });

        if (useHash) {
            const fromHash = () => {
                const key = decodeURIComponent(window.location.hash.replace('#', ''));
                if (key) activate(key);
            };

            fromHash();
            window.addEventListener('hashchange', fromHash);
        }
    };

    document.querySelectorAll('.sectors, .sectorTabs').forEach(initTabs);

});
